import React, { useEffect } from 'react';
import Datas from '../data/footer/footer2.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import BackToTop from './common/BackToTop';
import { Styles } from "./styles/footerTwo.js";

function FooterTwo() {
    useEffect(() => {
        const form = document.getElementById("form4");
        // const email = document.getElementById("email4");

        form.addEventListener("submit", (e) => {
            e.preventDefault();
        });
    });

    return (
        <Styles>
            {/* Footer */}
            <footer
                className="footer2"
                style={{ backgroundImage: `url(/assets/images/${Datas.backgroundImage})` }}
            >
                <Container>
                    <Row>

                        {/* Logo + Info */}
                        <Col md="3">
                            <div className="footer-logo-info">
                                <img src="/assets/images/logo2.png" alt="Care University" className="img-fluid" />

                                <p style={{textAlign:"justify"}}>
                                    Care University of Education is committed to providing quality education,
                                    modern learning facilities, and career-focused programs to help students
                                    achieve success in their professional journey.
                                </p>

                                <ul className="list-unstyled">
                                    <li><i className="las la-map-marker"></i>Near Golden Future Library <br /> Roorkee 247667</li>
                                    <li><i className="las la-envelope"></i> info@erptechpro.in</li>
                                    <li><i className="las la-phone"></i>+91 7599020021</li>
                                </ul>
                            </div>
                        </Col>

                        {/* Useful Links */}
                        <Col md="3">
                            <div className="f-links">
                                <h5>Quick Links</h5>
                                <ul className="list-unstyled">
                                    <li><Link to="/about"><i className="las la-angle-right"></i> About Us</Link></li>
                                    <li><Link to="/course-grid"><i className="las la-angle-right"></i> Courses</Link></li>
                                    <li><Link to="/gallery"><i className="las la-angle-right"></i> Gallery</Link></li>
                                    <li><Link to="/blog-grid"><i className="las la-angle-right"></i> Blog</Link></li>
                                    <li><Link to="/contact"><i className="las la-angle-right"></i> Contact Us</Link></li>
                                </ul>
                            </div>
                        </Col>

                        {/* Latest Posts */}
                        <Col md="3">
                            <div className="f-post">
                                <h5>Latest Updates</h5>

                                <div className="post-box d-flex">
                                    <div className="po-icon">
                                        <i className="las la-newspaper"></i>
                                    </div>
                                    <div className="po-content">
                                        <Link to="/blog-details/2">Importance of career guidance</Link>
                                        <span>20 Apr</span>
                                    </div>
                                </div>

                                <div className="post-box d-flex">
                                    <div className="po-icon">
                                        <i className="las la-newspaper"></i>
                                    </div>
                                    <div className="po-content">
                                        <Link to="/blog-details/3">Benefits of participating in science exhibition</Link>
                                        <span>27 Apr</span>
                                    </div>
                                </div>

                                <div className="post-box d-flex">
                                    <div className="po-icon">
                                        <i className="las la-newspaper"></i>
                                    </div>
                                    <div className="po-content">
                                        <Link to="/blog-details/6">How alunimi networking supports student success</Link>
                                        <span>05 May</span>
                                    </div>
                                </div>

                            </div>
                        </Col>

                        {/* Newsletter */}
                        <Col md="3">
                            <div className="f-newsletter">
                                <h5>Newsletter</h5>
                                <p>Subscribe to get latest updates, news and admission alerts.</p>

                                <form id="form4" className="form">
                                    <p className="form-control">
                                        <input type="email" placeholder="Enter your email" id="email4" />
                                        <span className="input-msg4"></span>
                                    </p>
                                    <button>Subscribe</button>
                                </form>
                            </div>
                        </Col>

                        {/* Bottom */}
                        <Col md="12">
                            <div className="copytext-area text-center">
                                <p>
                                    © {new Date().getFullYear()} Care University of Education. All Rights Reserved.
                                </p>

                                <ul className="social list-unstyled list-inline">
                                    <li className="list-inline-item"><a href="https://www.facebook.com/61580941010197/"><i className="fab fa-facebook-f"></i></a></li>
                                    <li className="list-inline-item"><a href="https://wa.me/917599020021"><i className="fab fa-whatsapp"></i></a></li>
                                    <li className="list-inline-item"><a href="https://youtube.com/@erptechpro?si=nhu16ox6xv46Kdx9"><i className="fab fa-youtube"></i></a></li>
                                    <li className="list-inline-item"><a href="https://www.instagram.com/erptechproofficial?igsh=MTN2NG9xbmJ0MTY1dg=="><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </Col>

                    </Row>
                </Container>

                <BackToTop />
            </footer>
        </Styles>
    );
}

export default FooterTwo;